import {
  CategoryNavigationMenu,
  CategoryNavigationMenuDisplayList,
  CategoryNavigationMenuText,
} from '@diritto/common/navigation/constant';
import styled from '@emotion/styled';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { RankingNavigationSeriesMenuPath } from 'constants/navigation';
import { LineSubMenu } from 'ui-components/navigations/LineSubMenu';
import { FeatureFlagName } from '@diritto/common/system/constants';
import { useMemo } from 'react';
import { useFeatureFlagConfig } from 'ui-hooks/useFeatureFlagConfig';

export const RankingSeriesNavigationBar = ({ selectedMenu }: { selectedMenu: CategoryNavigationMenu }) => {
  const { isActiveFlag } = useFeatureFlagConfig();
  const isFanFictionEnabled = isActiveFlag(FeatureFlagName.FanFiction);
  const categoryNavigationMenuDisplayList = useMemo(
    () =>
      CategoryNavigationMenuDisplayList.filter(
        menu => isFanFictionEnabled || menu !== CategoryNavigationMenu.FanFiction,
      ),
    [isFanFictionEnabled],
  );

  return (
    <StyledContainer>
      <StyledSubMenu
        menuList={categoryNavigationMenuDisplayList}
        menuPath={RankingNavigationSeriesMenuPath}
        menuText={CategoryNavigationMenuText}
        selectedMenu={selectedMenu}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(LineSubMenu)`
  position: relative;
  top: 0;
  left: 0;
`;
